import {Chips, ChipsOption} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {CommunicationThreadScope} from '../types/CommunicationThreadScope';

interface CommunicationThreadScopeChipsProps extends TestIdProps {
  value: CommunicationThreadScope;
  onChange: (value: CommunicationThreadScope) => void;
  size?: 'small' | 'default';
}

export function CommunicationThreadScopeChips(props: CommunicationThreadScopeChipsProps) {
  const scopeOptions: ChipsOption[] = [
    {value: 'customer', label: i18n.t('general.labels.customer')},
    {value: 'record', label: i18n.t('page.myProfile.receivingMailbox.syncedMessages.record')},
  ];

  return (
    <Chips
      value={[props.value]}
      size={props.size ?? 'small'}
      options={scopeOptions}
      onChange={(value) =>
        match(value?.[0])
          .with('customer', 'record', (scope) => props.onChange(scope))
          .otherwise(() => {})
      }
      data-testid={props['data-testid']}
    />
  );
}
